import React from "react";
import Navbar from "../../components/navigation/Navbar";
import { Link } from "react-router-dom";
import itemSlider1 from "../../assets/images/item-slider.jpg";
import itemSlider2 from "../../assets/images/item-slider2.jpg";
import itemSlider3 from "../../assets/images/item-slider3.jpg";
import ex6 from "../../assets/images/ex6.png";

// Mobilecrane Images
import kato from "../../assets/images/kato.png";
import tadano from "../../assets/images/tadano.png";
import sany from "../../assets/images/sany.png";
import sumitomo from "../../assets/images/sumitomo.png";
import grove from "../../assets/images/grove.png";
import kobelco from "../../assets/images/kobelco.png";
import liebherr from "../../assets/images/liebherr.png";
import zoomlion from "../../assets/images/zoomlion.png";
import terex from "../../assets/images/terex.png";
import xcmg from "../../assets/images/xcmg.png";

// forklifters Images
import warehouse from "../../assets/images/warehouse.png";
import sideLoader from "../../assets/images/sideLoader.png";
import counterbalance from "../../assets/images/counterbalance.png";
import telehandler from "../../assets/images/telehandler.png";
import heavyDuty from "../../assets/images/heavyDuty.png";
import rough from "../../assets/images/rough.png";
import pallet from "../../assets/images/pallet.png";
import walkie from "../../assets/images/walkie.png";
import order from "../../assets/images/order.png";
import reach from "../../assets/images/reach.png";

// Crawler Images
import crawler from "../../assets/images/crawler.png";
import wheeled from "../../assets/images/wheeled.png";
import dragline from "../../assets/images/dragline.png";
import suction from "../../assets/images/suction.png";
import skid from "../../assets/images/skid.png";
import longReach from "../../assets/images/longReach.png";
import mini from "../../assets/images/mini.png";

// Loader Images
import backhoe from "../../assets/images/backhoe.png";
import steer from "../../assets/images/steer.png";

// Roller Images
import drum from "../../assets/images/drum.png";
import tamping from "../../assets/images/tamping.png";
import padfoot from "../../assets/images/padfoot.png";
import vibratory from "../../assets/images/vibratory.png";
import smooth from "../../assets/images/smooth.png";

import missionHome from "../../assets/images/mission-image.png";
import lineTop from "../../assets/images/line-top.png";
import lineBottom from "../../assets/images/line-bottom.png";
import NorthEastOutlinedIcon from "@mui/icons-material/NorthEastOutlined";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Footer from "../../components/footer/Footer";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import { Autoplay, Navigation, Pagination, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import { ProductContext } from "../../Contexts/ProductContext";
import { Skeleton } from "@mui/material";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function a11yProps2(index) {
  return {
    id: `simple-tab2-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Home = () => {
  const { products, loading } = React.useContext(ProductContext);
  const [value, setValue] = React.useState(0);
  const [value2, setValue2] = React.useState(0);
  const [rentProducts, setRentProducts] = React.useState([]);
  const [buyProducts, setBuyProducts] = React.useState([]);
  const [ploading, setpLoading] = React.useState(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChange2 = (event, newValue) => {
    setValue2(newValue);
  };

  React.useEffect(() => {
    if (!loading && products.length > 0) {
      setpLoading(true);

      const sortedProducts = [...products].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );

      const rentItems = sortedProducts
        .filter((product) => product.prdCategory === "Rent")
        .slice(0, 6);
      const buyItems = sortedProducts
        .filter((product) => product.prdCategory === "Buy")
        .slice(0, 6);

      setRentProducts(rentItems);
      setBuyProducts(buyItems);
      setpLoading(false);
    } else {
      // toast.error("No products available");
    }
  }, [loading, products]);

  const formatProductTitle = (title, id) => {
    const formattedTitle = title.split(" ").join("-");
    return `/productDetail/${formattedTitle}/${id}`;
  };

  return (
    <div>
      <Navbar />
      <div className="slider-banner">
        <Swiper
          spaceBetween={0}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          speed={1000}
          loop={true}
          modules={[Autoplay, Navigation, Pagination]}
        >
          <SwiperSlide>
            <div className="slider-item">
              <img src={itemSlider1} alt="Slider 1" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="slider-item">
              <img src={itemSlider2} alt="Slider 2" />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="slider-item">
              <img src={itemSlider3} alt="Slider 3" />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      <section className="brand-section">
        <div className="container">
          <h6 className="heading6">
            We offer top-of-the-line machinery from
            <span>industry-leading brands</span>, providing reliable solutions
            for all your construction needs
          </h6>

          <Box sx={{ width: "100%", marginTop: "2rem" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value2}
                onChange={handleChange2}
                aria-label="basic tabs example"
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
              >
                <Tab label="Mobile Crane" {...a11yProps2(0)} />
                <Tab label="Forklifts" {...a11yProps2(1)} />
                <Tab label="Excavators" {...a11yProps2(2)} />
                <Tab label="Loader" {...a11yProps2(3)} />
                <Tab label="Roller" {...a11yProps2(4)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value2} index={0}>
              <div className="brand-row">
                <div className="brand-wrap">
                  <img src={kato} alt="Kato Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={tadano} alt="Tadano Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={sany} alt="Sany Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={sumitomo} alt="Sumitomo Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={grove} alt="Grove Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={kobelco} alt="Kobelco Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={liebherr} alt="Liebherr Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={zoomlion} alt="Zoomlion Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={terex} alt="Terex Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={xcmg} alt="Xcmg Logo" />
                </div>
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value2} index={1}>
              <div className="brand-row">
                <div className="brand-wrap">
                  <img src={warehouse} alt="Kato Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={sideLoader} alt="Tadano Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={counterbalance} alt="Sany Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={telehandler} alt="Sumitomo Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={heavyDuty} alt="Liebherr Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={rough} alt="Zoomlion Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={pallet} alt="Terex Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={walkie} alt="Xcmg Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={order} alt="Xcmg Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={reach} alt="Xcmg Logo" />
                </div>
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value2} index={2}>
              <div className="brand-row">
                <div className="brand-wrap">
                  <img src={crawler} alt="crawler Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={wheeled} alt="wheeled Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={dragline} alt="dragline Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={suction} alt="Sumitomo Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={skid} alt="skid Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={longReach} alt="longReach Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={mini} alt="mini Logo" />
                </div>
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value2} index={3}>
              <div className="brand-row">
                <div className="brand-wrap">
                  <img src={backhoe} alt="backhoe Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={steer} alt="steer Logo" />
                </div>
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value2} index={4}>
              <div className="brand-row">
                <div className="brand-wrap">
                  <img src={drum} alt="crawler Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={tamping} alt="wheeled Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={padfoot} alt="dragline Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={vibratory} alt="Sumitomo Logo" />
                </div>
                <div className="brand-wrap">
                  <img src={smooth} alt="skid Logo" />
                </div>
              </div>
            </CustomTabPanel>
          </Box>
        </div>
      </section>

      <section className="pt-[3rem] pb-[6rem]">
        <div className="container">
          <div className="about-row">
            <div className="about-img">
              <img src={ex6} alt="About Us" />
            </div>

            <div className="about-content">
              <small className="small-text">
                <span></span> About AGA
              </small>
              <h1>We are the heavy machinery expert</h1>
              <p>
                Amin Grand Asia Construction Equipment and Machinery Trading LLC
                is a premier provider of heavy equipment solutions, specializing
                in mobile cranes, tower cranes, and more. We offer comprehensive
                services for trading, rental projects, and import/export,
                catering to the diverse needs of the construction industry. With
                offices in Dubai and Sharjah, we are committed to delivering
                high-quality, reliable equipment to support your projects across
                the UAE.
              </p>

              <p>
                With our extensive industry experience, we have built a
                reputation for being a trusted partner in the construction
                sector, providing tailored solutions that drive project success.
              </p>

              <div className="about-wrap-btns">
                <Link to="/about-us" className="btn-home btn-learn-more">
                  Learn More
                  <NorthEastOutlinedIcon
                    sx={{ fontSize: "20px", marginLeft: "8px" }}
                  />
                </Link>

                <Link to="/productlists" className="btn-home btn-products-more">
                  See Products
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-product">
        <div className="container">
          <div className="flex-hdng">
            <div>
              <div className="small-text">
                <span></span> Explore our Products
              </div>
              <h1 className="heading1">Our Latest Products</h1>
            </div>

            <div>
              <Link to="/productlists" className="btn-home btn-outline-red">
                See All Products
                <NorthEastOutlinedIcon
                  sx={{ fontSize: "20px", marginLeft: "8px" }}
                />
              </Link>
            </div>
          </div>
          <Box sx={{ width: "100%", marginTop: "2rem" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="For Sale" {...a11yProps(0)} />
                <Tab label="Rentals" {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <div className="flex gap-3 flex-wrap">
                {ploading ? (
                  <div className="flex gap-3 flex-wrap">
                    {[1, 2, 3, 4, 5, 6].map((item) => (
                      <ProductSkeleton key={item} />
                    ))}
                  </div>
                ) : buyProducts.length > 0 ? (
                  buyProducts.map((product) => (
                    <div className="product-card" key={product.id}>
                      <div className="product-image">
                        <img
                          src={product.images[0] || "default-image.jpg"}
                          alt={product.title}
                        />
                        {product?.prdStock === "Out of Stock" ? (
                          <span className="stockTag">Sold Out</span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="flex justify-between gap-5 product-info">
                        <h2>{product.title}</h2>
                        <div className="label-category bgSkyBlue">
                          {`for ${product.prdCategory}`}
                        </div>
                      </div>
                      <ul className="product-tags">
                        <span>
                          <FitnessCenterIcon
                            sx={{ fontSize: "15px", marginRight: "6px" }}
                          />
                          {`${product.prdModel}`}
                        </span>
                        <span>
                          <PowerSettingsNewIcon
                            sx={{ fontSize: "15px", marginRight: "6px" }}
                          />
                          {`${product.prdBrand}`}
                        </span>
                      </ul>

                      <Link
                        to={formatProductTitle(product.title, product._id)}
                        className="product-btn"
                      >
                        See Details
                      </Link>
                    </div>
                  ))
                ) : (
                  <p>No products available for sale</p>
                )}
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <div className="flex gap-3 flex-wrap">
                {ploading ? (
                  <div className="flex gap-3 flex-wrap">
                    {[1, 2, 3, 4, 5, 6].map((item) => (
                      <ProductSkeleton key={item} />
                    ))}
                  </div>
                ) : rentProducts.length > 0 ? (
                  rentProducts.map((product) => (
                    <div className="product-card" key={product.id}>
                      <div className="product-image">
                        <img
                          src={product.images[0] || "default-image.jpg"}
                          alt={product.title}
                        />
                        {product?.prdStock === "Out of Stock" ? (
                          <span className="stockTag">Rent Out</span>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="flex justify-between gap-5 product-info">
                        <h2>{product.title}</h2>
                        <div className="label-category bgRed">
                          {`for ${product.prdCategory}`}
                        </div>
                      </div>
                      <ul className="product-tags">
                        <span>
                          <FitnessCenterIcon
                            sx={{ fontSize: "15px", marginRight: "6px" }}
                          />
                          {`${product.prdModel}`}
                        </span>
                        <span>
                          <PowerSettingsNewIcon
                            sx={{ fontSize: "15px", marginRight: "6px" }}
                          />
                          {`${product.prdBrand}`}
                        </span>
                      </ul>

                      <Link
                        to={formatProductTitle(product.title, product._id)}
                        className="product-btn"
                      >
                        See Details
                      </Link>
                    </div>
                  ))
                ) : (
                  <p>No products available for rent</p>
                )}
              </div>
            </CustomTabPanel>
          </Box>
        </div>
      </section>

      <section className="pt-[5rem] pb-[6rem]">
        <div className="container">
          <div className="about-row">
            <div className="about-content">
              <small className="small-text">
                <span></span> Our Mission
              </small>
              <h1>Pioneering Digital Machinery Solutions</h1>
              <p>
                Our mission is to provide high-quality equipment solutions that
                empower construction and industrial projects to succeed. Whether
                you are looking to purchase or rent equipment, we offer flexible
                and reliable options designed to meet the unique requirements of
                your project.
              </p>

              <p>
                At Amin Grand Asia, we are committed to excellence in service
                and precision in equipment. We take pride in our ability to
                offer industry-leading machinery that delivers on both
                performance and safety. Our dedicated team ensures that every
                piece of equipment is well-maintained and ready to operate,
                giving you peace of mind for your most demanding projects.
              </p>

              <div className="about-wrap-btns">
                <Link to="/about-us" className="btn-home btn-learn-more">
                  Learn More
                  <NorthEastOutlinedIcon
                    sx={{ fontSize: "20px", marginLeft: "8px" }}
                  />
                </Link>
              </div>
            </div>

            <div className="about-img mission-image">
              <img src={missionHome} alt="Our Mission" />
            </div>
          </div>
        </div>
      </section>

      <section className="demographic-section relative">
        <img
          src={lineTop}
          alt="Background Lines"
          className="absolute top-0 left-0 h-full"
        />
        <div className="container">
          <div className="text-center sec-hdng">
            <div className="small-text justify-center">
              <span></span> Our Achivements
            </div>
            <h1>
              25 strong years of fulfilling the world's demand for heavy
              machinery.
            </h1>
          </div>

          <div className="demo-box-row">
            <div className="demo-box">
              <h1>25+</h1>
              <p>Years In Business</p>
            </div>
            <div className="demo-box">
              <h1>500+</h1>
              <p>Orders Fulfilled</p>
            </div>
            <div className="demo-box">
              <h1>90+</h1>
              <p>Operators</p>
            </div>
            <div className="demo-box">
              <h1>60+</h1>
              <p>Machinery In Stock</p>
            </div>
          </div>
        </div>
        <img
          src={lineBottom}
          alt="Background Lines"
          className="absolute top-0 right-0 h-full"
        />
      </section>

      <section className="pt-[4rem] pb-[4rem]">
        <div className="container">
          <div className="">
            <div className="small-text">
              <span></span> New Inventory
            </div>
            <h1 className="heading1">Brand - New Arrivals</h1>
          </div>

          <Swiper
            spaceBetween={20}
            slidesPerView={3}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              240: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
              540: {
                slidesPerView: 2,
                spaceBetween: 0,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 10,
              },
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay, Navigation, Pagination]}
          >
            {ploading ? (
              <div className="flex gap-3 flex-wrap">
                {[1, 2, 3].map((item) => (
                  <ProductSkeleton key={item} />
                ))}
              </div>
            ) : buyProducts.length > 0 ? (
              buyProducts.map((product) => (
                <SwiperSlide className="mt-10">
                  <div className="product-card" key={product.id}>
                    <div className="product-image">
                      <img
                        src={product.images[0] || "default-image.jpg"}
                        alt={product.title}
                      />
                      {product?.prdStock === "Out of Stock" ? (
                        <span className="stockTag">Sold Out</span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="flex justify-between gap-5 product-info">
                      <h2>{product.title}</h2>
                      <div className="label-category bgSkyBlue">
                        {`for ${product.prdCategory}`}
                      </div>
                    </div>
                    <ul className="product-tags">
                      <span>
                        <FitnessCenterIcon
                          sx={{ fontSize: "15px", marginRight: "6px" }}
                        />
                        {`${product.prdModel}`}
                      </span>
                      <span>
                        <PowerSettingsNewIcon
                          sx={{ fontSize: "15px", marginRight: "6px" }}
                        />
                        {`${product.prdBrand}`}
                      </span>
                    </ul>

                    <Link
                      to={formatProductTitle(product.title, product._id)}
                      className="product-btn"
                    >
                      See Details
                    </Link>
                  </div>
                </SwiperSlide>
              ))
            ) : (
              <p>No products available for rent</p>
            )}
          </Swiper>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;

const ProductSkeleton = () => (
  <div className="product-card">
    <div className="product-image">
      <Skeleton variant="rectangular" width="100%" height={200} />
    </div>
    <div className="flex justify-between gap-5 product-info">
      <Skeleton variant="text" width="60%" />
      <Skeleton variant="rectangular" width="30%" height={24} />
    </div>
    <ul className="product-tags">
      <span>
        <Skeleton variant="text" width={100} />
      </span>
      <span>
        <Skeleton variant="text" width={100} />
      </span>
    </ul>
    <Skeleton variant="rectangular" width="100%" height={40} />
  </div>
);
